<template>
    <div id="audio-player-root" style="white-space:nowrap;">

        <!-- Hide the default audio player -->
        <div >
            <audio
                style="display:none"
                ref="player"
                :id="playerid"
            >
                <source :src="url" type="audio/mpeg" />
            </audio>
        </div>
        <span class="pr-2">{{label}}</span>
        <v-progress-circular v-if="isPlaying || percentProgress() > 0" :value="percentProgress()" :color="isPlaying ? 'lime' : 'grey'">
            <template slot:default>
                <v-btn icon 
                    @click="toggleAudio()"
                    v-show="!isPlaying"
                >
                    <v-icon>mdi-play-circle</v-icon>
                </v-btn>
                <v-btn icon 
                    @click="toggleAudio()"
                    v-show="isPlaying"
                >
                    <v-icon>mdi-pause-circle</v-icon>
                </v-btn>
            </template>
        </v-progress-circular>

        <v-btn v-else icon 
            @click="toggleAudio()"
        >
            <v-icon>mdi-play-circle</v-icon>
        </v-btn>

        <span v-if="expanded">
            <v-btn icon 
                @click="stopAudio()"
            >
                <v-icon>mdi-stop-circle</v-icon>
            </v-btn>
        </span>
        <span class="text-sm mx-2" style="color: #94bcec" v-html="elapsed_time"> 0:00 </span>
        <span class="text-sm" style="color: #94bcec" v-html="totalTime()"> 0:00 </span>
    </div>
</template>

<script>
//import { mapState } from 'vuex'
export default {
    props: ["url", "playerid", "label", "expanded"],
    /**
     * playbackTime = local var that syncs to audio.currentTime
     * audioDuration = duration of audio file in seconds
     * isPlaying = boolean (true if audio is playing)
     *
     **/
    data() {
        return {
            playbackTime: 0,
            audioDuration: 100,
            audioLoaded: false,
            isPlaying: false,
            interval: null,
            elapsed_time: '0:00'
        };
    },
    mounted: function() {
        console.log("exp: ", this.expanded)
    },
    methods: {
        //Set the range slider max value equal to audio duration
        initSlider() {
            var audio = this.$refs.player;
            if (audio) {
                this.audioDuration = Math.round(audio.duration);
            }
        },
        //Convert audio current time from seconds to min:sec display
        convertTime(seconds){
                const format = val => `0${Math.floor(val)}`.slice(-2);
                var hours = seconds / 3600;
                var minutes = (seconds % 3600) / 60;
                // return [minutes, seconds % 60].map(format).join(":");
                return Math.floor(minutes)+":"+format(seconds)
        },
        //Show the total duration of audio file
        totalTime() {
            var audio = this.$refs.player;
            if (audio) {
                var seconds = audio.duration;
                return seconds > 0 ? this.convertTime(seconds) : '0:00';
            } else {
                return '0:00';
            }
        },
        percentProgress() {
            var audio = this.$refs.player;
            if (audio) {
                let percentage = audio.currentTime/audio.duration*100
                return percentage
            }
            return 0
        },
        //Display the audio time elapsed so far
        checkElapsedTime() {
            this.elapsed_time = this.elapsedTime()
        },
        elapsedTime() {
            var audio = this.$refs.player;
            if (audio) {
                var seconds = audio.currentTime;
                return this.convertTime(seconds);
            } else {
                return '0:00';
            }
        },
        //Playback listener function runs every 100ms while audio is playing
        playbackListener(e) {
            var audio = this.$refs.player;
            //Sync local 'playbackTime' var to audio.currentTime and update global state
            this.playbackTime = audio.currentTime;
            
            //Add listeners for audio pause and audio end events
            audio.addEventListener("ended", this.endListener);
            audio.addEventListener("pause", this.pauseListener);
        },
        //Function to run when audio is paused by user
        pauseListener() {
            this.isPlaying = false;
            this.listenerActive = false;
            this.cleanupListeners();
            this.interval = null
        },
        //Function to run when audio play reaches the end of file
        endListener() {
            this.isPlaying = false;
            this.listenerActive = false;
            this.cleanupListeners();
            this.interval = null
        },
        //Remove listeners after audio play stops
        cleanupListeners() {
            var audio = this.$refs.player;
            audio.removeEventListener("freqtimeupdate", this.playbackListener);
            audio.removeEventListener("ended", this.endListener);
            audio.removeEventListener("pause", this.pauseListener);
        },
        toggleAudio() {
            var audio = this.$refs.player;
            //var audio = document.getElementById("audio-player");
            if (audio.paused) {
                audio.play();
                this.isPlaying = true;
                this.createInterval()
            } else {
                audio.pause();
                this.isPlaying = false;
            }
        },
        stopAudio() {
            var audio = this.$refs.player;
            this.isPlaying = false;
            audio.pause();
            audio.load();
        },
        createInterval() {
            if(this.interval == null) {
                let g = this
                this.interval = setInterval(function() {
                    g.checkElapsedTime()                    
                }, 500)
            }
        }
    },
    mounted: function() {
      // nextTick code will run only after the entire view has been rendered
      this.$nextTick(function() {
        
        var audio=this.$refs.player;
        //Wait for audio to load, then run initSlider() to get audio duration and set the max value of our slider 
        // "loademetadata" Event https://www.w3schools.com/tags/av_event_loadedmetadata.asp
        audio.addEventListener(
          "loadedmetadata",
          function(e) {
            this.initSlider();
          }.bind(this)
        );
        // "canplay" HTML Event lets us know audio is ready for play https://www.w3schools.com/tags/av_event_canplay.asp
        audio.addEventListener(
          "canplay",
          function(e) {
            this.audioLoaded=true;
          }.bind(this)
        );
        //Wait for audio to begin play, then start playback listener function
        this.$watch("isPlaying",function() {
          if(this.isPlaying) {
            var audio=this.$refs.player;
            this.initSlider();
            //prevent starting multiple listeners at the same time
            if(!this.listenerActive) {
              this.listenerActive=true;
              audio.addEventListener("freqtimeupdate",this.playbackListener);
            }
          }
        });
        //Update current audio position when user drags progress slider
        this.$watch("playbackTime",function() {
            var audio=this.$refs.player;
        var diff=Math.abs(this.playbackTime-this.$refs.player.currentTime);
        
          //Throttle synchronization to prevent infinite loop between playback listener and this watcher
          if(diff>0.01) {
            this.$refs.player.currentTime=this.playbackTime;
          }
        });
      });
    }
};
</script>

<style>
/* Play/Pause Button */
.play-button{
    height: 45px
}
input[type="range"] {
    margin: auto;
    -webkit-appearance: none;
    position: relative;
    overflow: hidden;
    width: 100%;
    cursor: pointer;
    outline: none;
    border-radius: 0; /* iOS */
    background: transparent;
}
input[type="range"]:focus {
    outline: none;
}
::-webkit-slider-runnable-track {
    background: #fff;
}
/*
 * 1. Set to 0 width and remove border for a slider without a thumb
 */
::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 0; /* 1 */
    height: 40px;
    background: #fff;
    box-shadow: -100vw 0 0 100vw dodgerblue; 
    border: none; /* 2px solid #999; */
}
::-moz-range-track {
    height: 40px;
    background: #ddd;
}
::-moz-range-thumb {
    background: #fff;
    height: 40px;
    width: 0; /* 20px; */
    border: none; /* 3px solid #999; */
    border-radius: 0 !important;
    box-shadow: -100vw 0 0 100vw dodgerblue; 
    box-sizing: border-box;
}
::-ms-fill-lower {
    background: dodgerblue;
}
::-ms-thumb {
    background: #fff;
    border: 2px solid #999;
    height: 40px;
    width: 20px;
    box-sizing: border-box;
}
::-ms-ticks-after {
    display: none;
}
::-ms-ticks-before {
    display: none;
}
::-ms-track {
    background: #ddd;
    color: transparent;
    height: 40px;
    border: none;
}
::-ms-tooltip {
    display: none;
}
</style>